import { batchFetchSurchargeMargin } from 'api/reservation'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { useEffect, useState } from 'react'

interface Params {
  checkIn: moment.Moment | undefined
  duration: number
  ratePlanId: string | undefined
}

function useSurchargeMarginFetcher(params: Params) {
  const { checkIn, duration, ratePlanId } = params
  const [surchargeMargin, setSurchargeMargin] = useState < { marginAud } >({ marginAud: 0 })

  useEffect(() => {
    async function fetchSurchargeMargin() {
      if (!checkIn || !ratePlanId || !duration) {
        return
      }

      const result = await batchFetchSurchargeMargin([ratePlanId, {
        startDate: checkIn.format(ISO_DATE_FORMAT),
        // endDate is not inclusive
        endDate: checkIn.clone().add(duration, 'days').format(ISO_DATE_FORMAT),
      }], undefined)

      setSurchargeMargin(result)
    }

    fetchSurchargeMargin()
  }, [checkIn, duration, ratePlanId])

  return surchargeMargin
}

export default useSurchargeMarginFetcher
